
export const projects = [
  {
    id: 1,
    title: '高级前端工程师',
    clientId: 1,
    clientName: '阿里巴巴集团',
    status: '招聘中',
    priority: '高',
    startDate: '2024-01-10',
    deadline: '2024-02-10',
    salary: '25K-40K',
    location: '杭州',
    experienceRequired: '3-5年',
    education: '本科及以上',
    headcount: 2,
    currentApplications: 15,
    description: '负责前端架构设计和核心功能开发，要求熟练掌握React、Vue等前端框架',
    requirements: ['3年以上前端开发经验', '熟练掌握React/Vue', '有大型项目经验', '良好的团队合作能力'],
    assignedTalents: [1, 2],
    operator: '张三',
    createdAt: '2024-01-10'
  },
  {
    id: 2,
    title: 'Java后端开发工程师',
    clientId: 2,
    clientName: '腾讯科技',
    status: '面试中',
    priority: '中',
    startDate: '2024-01-08',
    deadline: '2024-02-08',
    salary: '20K-35K',
    location: '深圳',
    experienceRequired: '5-8年',
    education: '本科及以上',
    headcount: 3,
    currentApplications: 22,
    description: '负责后端服务开发和系统架构优化，要求有高并发处理经验',
    requirements: ['5年以上Java开发经验', '熟悉Spring框架', '有微服务架构经验', '熟悉MySQL和Redis'],
    assignedTalents: [3],
    operator: '李四',
    createdAt: '2024-01-08'
  },
  {
    id: 3,
    title: '产品经理',
    clientId: 3,
    clientName: '字节跳动',
    status: '已完成',
    priority: '高',
    startDate: '2023-12-15',
    deadline: '2024-01-15',
    salary: '30K-50K',
    location: '北京',
    experienceRequired: '3-5年',
    education: '本科及以上',
    headcount: 1,
    currentApplications: 18,
    description: '负责产品规划和用户体验优化，要求有互联网产品经验',
    requirements: ['3年以上产品经验', '熟悉用户研究方法', '具备数据分析能力', '有移动端产品经验'],
    assignedTalents: [4],
    operator: '王五',
    createdAt: '2023-12-15'
  },
  {
    id: 4,
    title: 'UI设计师',
    clientId: 4,
    clientName: '美团',
    status: '暂停',
    priority: '低',
    startDate: '2024-01-05',
    deadline: '2024-02-05',
    salary: '15K-25K',
    location: '北京',
    experienceRequired: '2-4年',
    education: '专科及以上',
    headcount: 2,
    currentApplications: 12,
    description: '负责产品界面设计和用户体验设计，要求有移动端设计经验',
    requirements: ['2年以上UI设计经验', '熟练使用设计软件', '有移动端设计经验', '良好的审美能力'],
    assignedTalents: [2],
    operator: '赵六',
    createdAt: '2024-01-05'
  }
];
